import { render, staticRenderFns } from "./appAdvertising.vue?vue&type=template&id=83090438&scoped=true&"
import script from "./appAdvertising.vue?vue&type=script&lang=js&"
export * from "./appAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./appAdvertising.vue?vue&type=style&index=0&id=83090438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83090438",
  null
  
)

export default component.exports